import Vue from 'vue'
import { makeQueryStringDync, errorServeiceHandler } from '../helper'
const state = {
}
const getters = {
}
const mutations = {
}
const actions = {
  getAlertMessage: (context, dataObj) => {
    return new Promise((resolve, reject) => {
      let queryStr = ''
      queryStr = makeQueryStringDync(dataObj)
      fetch(context.getters.baseUrl + '/subscriber/v1/alertmessage' + queryStr, {
        method: 'GET'
      })
        .then(errorServeiceHandler)
        .then((response) => {
          return response.json()

        }).then((data) => {
            resolve(data)
        }).catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  state, getters, mutations, actions
};



// WEBPACK FOOTER //
// ./src/store/modules/alert.js